import {
    SET_NAVIGATION,
    RESET_NAVIGATION,
    TOGGLE_MOBILE_NAVIGATION,
} from 'vue/vuex/mutation-types';

export function setNavigation({ commit }, { level, idx, item }) {
    commit(SET_NAVIGATION, { level, idx, item });
}

export function resetNavigation({ commit }) {
    commit(RESET_NAVIGATION);
}

export function toggleMobileNavigation({ commit }, { isOpen }) {
    commit(TOGGLE_MOBILE_NAVIGATION, { isOpen });
}



// WEBPACK FOOTER //
// ./sib-website/assets/src/js/app/vue/vuex/modules/main-nav/actions.js